import React from 'react';
import './SearchTabErrorMessage.scss';
import searchBarError from '../../../../assets/icons/search-bar-empty-error.svg';
import { useTranslation } from 'react-i18next';

interface searchTabProps {
    search: any;
}

const SearchTabErrorMessage: React.FC<searchTabProps> = ({ search }) => {
    const { t } = useTranslation();

    return (
        <div className='contentError'>
            <div className='img-content'>
                <img src={searchBarError} alt="img-search-error" />
            </div>

            <div>
                <p className='title-error'>{`${t('your_search_message')} "${search}" ${t('no_matches_message')}`}</p>
                <p className='description-error'>{t('check_filters_message')}</p>
            </div>
        </div>
    )
}

export default SearchTabErrorMessage